import PropTypes from 'prop-types';
import React from 'react';

import * as AppPropTypes from '../../lib/PropTypes';

const transform = {
    right: null,
    left: 'rotate(180deg)',
    top: 'rotate(-90deg)',
    bottom: 'rotate(90deg)',
};

const propTypes = {
    direction: AppPropTypes.arrowDirection,
    color: PropTypes.string,
    className: PropTypes.string,
};

const defaultProps = {
    direction: 'right',
    color: 'currentColor',
    className: null,
};

const Arrow = ({ direction, color, className }) => (
    <svg
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        x="0"
        y="0px"
        width="30px"
        height="30px"
        viewBox="0 0 30 30"
        className={className}
        xmlSpace="preserve"
    >
        <g style={{ transformOrigin: 'center', transform: transform[direction] }}>
            <path
                d="M30,13.13v3.74A15.52,15.52,0,0,0,19.76,29.56H16.1c.73-7.47,5.12-11.2,8.78-12.69H0V13.13H24.88c-3.66-1.49-8-5.22-8.78-12.69h3.66A15.52,15.52,0,0,0,30,13.13Z"
                fill={color}
            />
        </g>
    </svg>
);

Arrow.propTypes = propTypes;
Arrow.defaultProps = defaultProps;

export default Arrow;
